module.exports = __webpack_public_path__ + "img/logo.834842ed.png";